import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import FloatingHelpButton from '../components/landing/FloatingHelpButton';
import ChatWidget from '../components/ChatWidget/ChatWidget';
import './AboutUs.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const AboutUs = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/landing_page_api.php/pages/about_us`);
      if (response.data.status === 'success') {
        setPageData(response.data.data);
      }
    } catch (error) {
      console.error('Failed to load page content:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderSection = (section) => {
    return (
      <section key={section.id} className="about-section">
        <h2>{section.section_title}</h2>
        <div dangerouslySetInnerHTML={{ __html: section.section_content }} />
      </section>
    );
  };

  if (loading) {
    return (
      <div className="about-us-page">
        <Header />
        <div className="loading-container" style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="about-us-page">
      <Header />

      <div className="about-hero">
        <div className="container">
          <h1>{pageData?.page_title || 'About eHaazri'}</h1>
          <p>{pageData?.page_subtitle || 'Revolutionizing Attendance Management with Smart Technology'}</p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          {pageData?.sections && pageData.sections.length > 0 ? (
            pageData.sections.map(renderSection)
          ) : (
            <>
              <section className="about-section">
                <h2>Our Story</h2>
                <p>
                  eHaazri was born from a simple observation: traditional attendance systems are outdated,
                  inefficient, and prone to manipulation. We set out to create a modern, intelligent solution
                  that leverages cutting-edge technology to make attendance management effortless and accurate.
                </p>
                <p>
                  Founded by a team of technology enthusiasts and HR professionals, eHaazri combines deep
                  industry knowledge with innovative thinking to deliver a product that truly meets the needs
                  of modern organizations.
                </p>
              </section>

              <section className="about-section">
                <h2>Our Mission</h2>
                <p>
                  To empower organizations with intelligent, reliable, and user-friendly attendance management
                  solutions that save time, reduce costs, and enhance productivity. We believe that managing
                  attendance should be simple, transparent, and fraud-proof.
                </p>
              </section>

              <section className="about-section">
                <h2>Our Vision</h2>
                <p>
                  To become the global standard for smart attendance management, helping organizations of all
                  sizes streamline their workforce management through innovation and technology excellence.
                </p>
              </section>
            </>
          )}

        </div>
      </div>

      <Footer />
      <FloatingHelpButton />
      <ChatWidget />
    </div>
  );
};

export default AboutUs;
